﻿export default {
    editor: {
        back_to_list: "Back to List",
        new_episode: "New Episode",
        untitled_episode: "Untitled Episode",
        edit: "Edit",
        delete: "Delete",
        webtoon_editor: "Webtoon Editor",
        episode_prefix: "Episode",
        preview: "Preview",
        live_preview: "Live Preview",
        preview_hint: "Check the preview",
        input_title_placeholder: "Enter episode title",
        display_mode: "Display Mode",
        mode_webtoon: "Vertical Scroll (Webtoon)",
        mode_comic: "Horizontal View (Comics)",
        mode_insta: "InstaToon",
        mode_desc: "Preview mode changes based on selection.",
        thumbnail: "Thumbnail",
        upload_image: "Upload Image",
        bgm: "Background Music (BGM)",
        manuscript_images: "Manuscript Images",
        drag_drop_hint: "Drag and drop images or click to upload.",
        save: "Save",
        save_draft: "Save Draft",
        save_changes: "Save Changes",
        publish: "Publish",
        publish_now: "Publish Now",
        set_draft: "Switch to Draft",
        publish_settings: "Publish Settings",
        saving: "Saving...",
        saved: "Saved",
        processing: "Processing...",
        publish_confirm: "Do you want to publish?",
        publish_complete: "Publish complete.",
        publish_success: "Successfully published.",
        published: "Published",
        published_start_ai: "Publishing started. Running AI analysis.",
        save_complete: "Save Complete",
        save_required: "Save Required",
        upload_complete: "Upload Complete",
        upload_fail: "Upload Failed: ",
        upload_fail_desc: "Image upload failed.",
        draft_mode_title: "Draft Mode",
        draft_mode_private_desc: "This episode is private.",
        draft_mode_switched: "Switched to Draft Mode.",
        image_mode_mismatch: "Image mode mismatch ({mode})",
        invalid_format: "Invalid format.",
        mode_change_blocked_desc: "Cannot change mode as images exist. ({mode})",
        mode_change_blocked: "Cannot change mode",
        tap_nav_hint: "Tap left/right to navigate",
        ai_analyze_admin: "AI Analysis (Admin)",
        ai_analyze_local: "AI Context Analysis",
        ai_analyze_confirm: "Start AI Analysis?",
        ai_confirm: "AI Confirmation",
        ai_context_analysis_confirm: "Run Context Analysis? (Warning: Overwrites existing data)",
        ai_analyze_title: "AI Analysis",
        ai_requesting: "Requesting AI Analysis...",
        ai_analyzing: "Analyzing...",
        ai_analyzing_background: "Starting AI analysis in background...",
        ai_processing_title: "Processing",
        ai_no_items: "No items to analyze.\n{log}",
        ai_no_items_found: "No items found for analysis.",
        diagnosis_report: "Diagnosis Report",
        ocr_complete: "OCR Analysis Complete ({n} items)",
        seo_trigger: "SEO data generation scheduled.",
        ai_complete_desc: "AI Analysis Complete.",
        ai_error: "AI Analysis Error",
        ai_fail_msg: "AI Analysis Failed: {e}",

        // Novel Studio & Legacy Keys
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        complete: "Save Standard", // Use existing value "Save Standard" or "Save Complete"? Old one has "Save Standard". New one has "Save Complete" (key: save_complete). Key 'complete' is unique? No, I added 'save_complete' in top block. 'complete' is in old block. I should keep 'complete' just in case.
        pending_approval: "Pending Approval",
        approval_requested: "Approval Requested",
        approval_desc: "Your work has been submitted for approval.\\nIt will be published after administrator review.",
        error: "Error",
        ai_analyze_btn: "AI Analyze",

        novel_editor: "Webnovel Editor",
        auto_saved: "Auto Saved",
        untitled_chapter: "Untitled",
        chapter_title_placeholder: "Chapter Title",
        delete_title: "Delete Chapter",
        save_button: "Save",

        novel_info: "Novel Info",
        novel_title: "Novel Title",
        tags_placeholder: "Romance, Fantasy, Growth",
        chapter_list: "Chapter List",
        chapter_count: "Total {n} Episodes",
        add_empty_chapter: "Add Empty Chapter",

        public_toggle: "Public (Published)",
        private_toggle: "Private (Draft)",
        bgm_suno_label: "BGM Settings (Suno Auto-convert)",
        txt_upload: "Upload Text File (.txt)",
        content_placeholder: "Enter novel content...",
        note_placeholder: "Leave a note for readers...",

        ai_analysis_complete: "?쨼 AI Analysis Complete",
        recommend_keywords: "Recommended Keywords",
        hook: "Hook",
        analysis_saved: "* Analysis data (SEO) saved to server.",
        analysis_fail: "AI Analysis Failed",
        analysis_short: "Content is too short to analyze.",

        age_all: "All",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Rating",
        age_19_desc: "* Selecting 19+ will block minors and require identity verification.",
        age_lock_warning: "Warning: Once saved, authors cannot change this setting. Contact admin for changes.",

        preview_desc: "Check how it looks on mobile.",
        select_chapter: "Select a chapter",
        episode_placeholder: "ex) Episode 1. The Beginning",
        bgm_placeholder: "Suno AI URL...",
        cover_upload_fail: "Cover Upload Failed: ",
        save_fail: "Save Failed: "
    },
    common: {
        confirm: "Confirm",
        cancel: "Cancel",
        close: "Close",
        save: "Save",
        delete: "Delete",
        edit: "Edit",
        copy: "Copy",
        geo_desc: "We don't do marketing. Our AI does.",
        term_log_1: "Analyzing Content...",
        term_log_2: "Extracting Keywords...",
        term_log_3: "Injecting JSON-LD...",
        term_log_4: "Organic Growth +300%",

        // Missing Keys Added
        slider_old_title: "Old Method",
        slider_old_desc: "BLOCKS THE ART",
        slider_new_title: "Ssulwha Engine (R.A.P.S)",
        slider_new_desc_1: "\"This is how it should happen.\"",
        slider_new_desc_2: "The text floats naturally, preserving the artwork.",

        phone_analyzing: "Analyzing...",
        phone_detected: "Detected",
        phone_text_1: "Is this my destiny?",
        phone_cine_ep: "CINE-NOVEL EP.01",
        phone_cine_text_1: "The neon lights flickered, reflecting in his cold eyes.",
        phone_cine_text_2: "\"It's not just a translation,\" he muttered. \"It's a new reality.\"",

        footer_copyright: "Powered by R.A.P.S Engine.",
        loading: "Loading...",
        error: "An error occurred.",
        success: "Success.",
        webtoon: "Webtoon",
        webnovel: "Webnovel",
        cinenovel: "Cine-Novel",
        published: "Published",
        draft: "Draft",
        editor: "Editor"
    },
    footer: {
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        report: "Rights Violation Report",
        biz_ceo: "CEO",
        biz_addr: "Addr",
        biz_tel: "Support",
        biz_email: "Email",
        biz_license: "Biz License",
        biz_mail_order: "E-Commerce",
        biz_none: "Business Info Not Registered",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    auth: {
        attendance_success: "?뱟 Attendance Checked! (Daily Rewards)\nToday's bonus +50 points credited!",
        attendance_title: "Daily Bonus",
        signup_bonus: "Welcome! ?럦\nWelcome Bonus +100 points credited!",
        referral_bonus: "Referral Signup Complete! ?쩃\nWelcome Bonus 100P + Referral Bonus 500P\nTotal 600 points credited!",
        login_required: "Log in to discover more stories."
    },
    social: {
        subscribe_on: "Added to subscription list.",
        subscribe_off: "Subscription cancelled.",
        like_on: "Liked.",
        like_off: "Unliked."
    },
    comment: {
        submit_success: "Comment posted.",
        delete_confirm: "Are you sure you want to delete this comment?",
        delete_success: "Comment deleted.",
        empty_error: "Please enter content.",
        delete_error: "Delete failed",
        submit_error: "Failed to post comment"
    },
    payment: {
        verify_success: "Payment Complete!\n{amount} Stars credited.",
        verify_fail: "Payment successful but verification failed.",
        user_cancel: "Payment cancelled.",
        error: "An error occurred during payment."
    },
    menu: {
        home: "Home",
        webtoon: "Webtoons",
        webnovel: "Webnovels",
        novel: "Webnovels",
        davinci: "DaVinci",
        studio: "Creative Studio",
        library: "Library",
        support: "Support",
        admin: "Admin Page",
        config: "External Links",
        factory: "Popups & Notices",
        docs: "Doc Editor",
        analytics: "Analytics",
        plaza: "Ssulwha Club",
        charge: "Star Station",
        wisdom: "Wisdom of Stars",
        recommendation: "Empty Shelf",
        guide: "Guide",
        "whats-new": "What's New",
        invite: "Invite Friends",
        about: "About Service",
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        report: "Report Center",
        "app-setting": "App Settings",
        login: "Login / Sign Up",
        logout: "Log Out",
        MyPage: "My Page",
        notice: "Notices",
        proposal: "Feedback",
        settings: "Settings",
        language: "Language"
    },
    modal: {
        translate_title: "Select Language",
        translate_placeholder: "Please select a language to translate.",
        translate_start: "Start Translation"
    },
    profile: {
        mypage: "My Page",
        follow: "Follow",
        following: "Following",
        followers: "Followers",
        following_count: "Following",
        bio_empty: "No bio available.",
        works: "Works",
        feed: "Feed",
        guestbook: "Guestbook",
        works_empty: "No works found.",
        works_error: "Failed to load works.",
        feed_empty: "No feed posts found.",
        feed_error: "Failed to load feed.",
        feed_error_detail: "Might be indexing or network error.",
        follow_error: "An error occurred while following."
    },
    support: {
        title: "1:1 Support Center",
        input_placeholder: "Enter your inquiry...",
        empty_state_title: "No inquiries found.",
        empty_state_desc: "Ask us anything anytime!",
        status_received: " ??Received",
        auto_reply: "Your inquiry has been received. We will respond sequentially. In the meantime, please enjoy Ssulwha World.",
        send_fail: "Failed to send message"
    },
    guestbook: {
        title: "Guestbook",
        input_placeholder: "Leave a message...",
        submit: "Post",
        secret: "Secret",
        empty: "Be the first to leave a message!",
        reply: "Reply",
        reply_placeholder: "Write a reply...",
        secret_content: "Secret content (Only writer & admin can view)",
        submit_error: "Post failed: ",
        emoji_error: "Failed to load emoji picker",
        confirm_delete_reply: "Delete this reply?"
    },

    author: {
        apply_title: "Apply as Author",
        apply_desc: "Share your story with the world. Leave a brief introduction and portfolio, and we will contact you after review.",
        email_label: "Email",
        email_placeholder: "Enter contact email",
        email_hint: "We may contact you regarding approval results and contracts.",
        intro_label: "Introduction",
        intro_placeholder: "Please introduce yourself (Writing experience, style, etc.)",
        portfolio_label: "Portfolio (Optional)",
        submit_btn: "Apply Now",
        email_required: "Please enter your email.",
        intro_required: "Please enter your introduction.",
        submitting: "Submitting...",
        submit_success: "Author application submitted."
    },
    badge: {
        best_reviewer: "Best Reviewer",
        top_author: "Top Author",
        vip: "VIP",
        donation_king: "Donation King",
        hall_of_fame: "Hall of Fame"
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (??price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },
    history: {
        empty: {
            title: "No history yet.",
            desc: "Shall we explore some works?",
            action_btn: "Go Explore"
        },
        common: {
            no_title: "No Title"
        },
        last_viewed: "Last viewed:",
        episode_fmt: "Ep. {n}",
        delete_confirm: {
            msg: "Do you want to delete this history?",
            title: "Delete History"
        }
    },
    library: {
        empty_title: "Library is empty",
        empty_desc: "Purchased or viewed works will appear here.",
        explore_btn: "Explore Works",
        select_hint: "Select a work to view the list.",
        total_episodes: "Total {n} episodes"
    },
    tab: {
        works: "Works",
        feed: "Ssulwha (Feed)",
        guestbook: "Guestbook"
    },
    tag: {
        fantasy: "Fantasy",
        romance: "Romance",
        martial_arts: "Martial Arts",
        drama: "Drama",
        slice_of_life: "Slice of Life",
        comedy: "Comedy",
        thriller: "Thriller",
        school: "School Life",
        munchkin: "Overpowered",
        regression: "Time Travel",
        possession: "Possession",
        system: "System",
        growth: "Growth",
        revenge: "Revenge",
        heart: "Heart",
        horror: "Horror",
        sport: "Sports",
        history: "Alt-History"
    },

    pwa: {
        install_title: "Install App",
        install_desc: "Enjoy a faster and better experience.",
        install_btn: "Install",
        later_btn: "Later",
        ios_guide_title: "Install on iPhone",
        ios_guide_desc: "Enjoy the best experience on full screen.",
        ios_step1: "Tap the Share button",
        ios_step2: "Select 'Add to Home Screen'",
        update_title: "New Version ({version})!",
        update_title_v2: "A New Version is Available!",
        update_desc: "Update now for the latest features.",
        update_btn: "Update",
        updating: "Updating...",
        offline_title: "You are offline",
        offline_desc: "Please check your internet connection.",
        copy_success: "Copied to clipboard",
        copy_fail: "Copy failed"
    },
    settings: {
        title: "Application Settings",
        general: "General Settings",
        push_title: "Push Notifications",
        push_desc: "Receive update notifications",
        app_info: "App Info",
        current_version: "Current Version",
        danger_zone: "Danger Zone",
        delete_account_title: "Delete Account (Return to Reality)",
        delete_account_desc: "All data will be deleted and cannot be restored.",
        delete_account_button: "Return to Reality"
    },
    proposal: {
        title: "Wisdom of the Stars",
        desc: "Your shining wisdom expands the universe.",
        label_title: "Proposal Title",
        placeholder_title: "Enter the core of your idea",
        label_content: "Details",
        placeholder_content: "Feel free to share your ideas. The more specific, the better!",
        btn_submit: "Send Wisdom",
        success_title: "Wisdom Received",
        success_desc: "{name}'s wisdom has been received.<br>Thank you for your valuable feedback."
    },
    report: {
        title: "Report Center",
        category_label: "CATEGORY",
        content_label: "CONTENT",
        url_label: "RELATED URL",
        categories: {
            general: "General Inquiry / Other",
            spam: "Spam / Promotion",
            abuse: "Abusive Language / Hate Speech",
            adult: "Adult Content / Harmful to Minors",
            bug: "System Bug / Error"
        },
        placeholder_content: "Please describe the issue in detail.",
        btn_submit: "Submit Report",
        warning: "False reporting may result in service restrictions.",
        success_title: "Report Submitted",
        success_desc: "We will review and take action promptly.<br>Thank you for your report.",
        login_required: "Login required to report.",
        submit_success: "Report submitted successfully.",
        error: "Report submission error",
        modal: {
            title: "Report",
            desc: "Please select a reason. False reports may result in service restrictions.",
            category: "Category",
            detail: "Detail",
            url: "Related URL",
            submit: "Submit",
            cancel: "Cancel"
        },
        reason: {
            spam: "Spam / Promotion",
            abusive: "Abusive Language",
            inappropriate: "Inappropriate Content",
            other: "Other / Inquiry"
        }
    },
    guide: {
        title: "Under System Tuning",
        desc: "We are finely tuning the compass<br>to help your journey.",
        wait: "Please wait a moment."
    },
    seo: {
        default_title: "Ssulwha World - Where Imagination Becomes Reality",
        default_desc: "AI-powered Webtoon & Webnovel Platform. Create your own stories with AI.",
    },
    placeholder: {
        search: "Search works, authors, tags...",
        comment: "Write a comment...",
        guest_book: "Leave a message of support!",
        title_required: "Please enter a title.",
        content_required: "Please enter content."
    },
    toast: {
        login_success: "Logged in successfully.",
        copy_success: "Copied to clipboard.",
        network_error: "Network Error.",
        processing: "Processing..."
    },
    msg: {
        welcome_beta: "Welcome to Mirinae Platform Beta Service.",
        login_required: "Log in to discover more stories.",
        login_btn: "Log in / Sign up"
    },
    viewer: {
        settings_title: "Audio/Scroll Settings",
        bgm_volume: "BGM Volume",
        bgm_off: "No BGM",
        auto_speed: "Auto-Play Speed",
        settings_btn: "Settings",
        translate_btn: "AI Translate",
        tts_btn: "Read Aloud (TTS)",
        bgm_btn: "BGM",
        top_btn: "Top",
        auto_play: "Auto Slide",
        auto_scroll: "Auto Scroll",
        start_auto: "Auto-Play Started",
        stop_auto: "Auto-Play Stopped",
        tts_warn: "Note: TTS plays in the original language (Korean)."
    },
    login: {
        subtitle: "Where your imagination becomes reality",
        btn_google: "Continue with Google",
        or: "OR",
        label_email: "Email",
        label_password: "Password",
        btn_email_login: "Log in with Email",
        btn_email_signup: "Sign up with Email",
        msg_no_account: "Don't have an account?",
        msg_has_account: "Already have an account?",
        btn_signup: "Sign up",
        btn_login: "Log in",
        msg_processing: "Processing...",
        msg_email_sent: "Verification email sent. Please check and log in.",
        err_invalid_auth: "Invalid email or password.",
        err_email_in_use: "Email already in use.",
        err_default: "An error occurred."
    },
    terms: {
        title: "Immigration Check",
        desc: "Welcome to Ssulwha World.<br>Please agree to the terms to proceed.",
        required: "[Required]",
        optional: "[Optional]",
        label_terms: "Terms of Service",
        label_privacy: "Privacy Policy",
        label_marketing: "Marketing Consent",
        btn_start: "Get Started",
        btn_processing: "Processing..."
    },
    main: {
        banner_welcome: "Explore the fun Ssulwha World!",
        search_placeholder: "Search works, authors, tags...",
        hall_of_fame: "Hall of Fame (Weekly Best)",
        hall_of_fame_locked: "Hall of Fame is Members Only",
        hall_of_fame_desc: "Who is the top active user this week? Log in to check real-time rankings!",
        login_btn: "Go to Login",
        todays_pick: "Today's Pick",
        continue_reading: "Continue Reading",
        trending: "Trending Now",
        new_arrivals: "New Arrivals",
        all_works: "All Works",
        tag_cloud: "Browse by Tags",
        filter_all: "All",
        filter_webtoon: "Webtoon",
        filter_webnovel: "Webnovel",
        realtime_club: "Real-time Ssulwha Club",
        enter_club: "Enter Club",
        be_the_first: "Be the first to shoot a star!",
        go_to_plaza: "Go to Plaza",
        search_results: "Results for '{query}'",
        search_no_results: "No results found.",
        search_try_other: "Try searching with different keywords.",
        splash_loading: "Entering Ssulwha World..."
    },
    mypage: {
        tab_library: "Library",
        tab_history: "History",
        tab_activity: "Activity",
        tab_likes: "Liked",
        tab_wallet: "Wallet",
        tab_settings: "Settings",
        no_activity: "No activity yet.",
        go_to_plaza: "Go to Plaza",
        followers: "Followers",
        following: "Following",
        edit_profile_tooltip: "Edit Profile",
        role_author: "Author",
        role_reader: "Reader",
        role_admin: "Admin",
        author_pending: "??Author Approval Pending",
        btn_studio: "Creator Studio",
        btn_apply_author: "Apply as Author",
        default_bio: "Please enter a short bio.",
        menu_edit_profile: "Edit Profile",
        menu_public_profile: "View Public Profile",
        current_version: "Version Info",
        invite_title: "Invite Friends",
        invite_reward: "Reward +500P",
        invite_desc: "Share your invite link. You and your friend both get 500P!",
        invited_count: "Invited Friends",
        unit_people: "people",
        edit_profile_title: "Edit Profile",
        label_photo: "Profile Photo",
        btn_upload: "Upload",
        btn_random: "Random",
        placeholder_photo_url: "Or enter image URL",
        label_nickname: "Nickname",
        label_bio: "Bio",
        placeholder_bio: "Express yourself in one line."
    },
    plaza: {
        title: "SSULWHA CLUB",
        subtitle: "Emotional communication space for Gen Z, Ssulwha Club",
        btn_sync: "??Sync Comment Counts (Admin Only)",
        composer_placeholder_init: "What story would you like to launch into this universe?",
        composer_placeholder_thread: "Write the continuing story...",
        composer_placeholder_quote: "Leave your thoughts on this story...",
        btn_add_thread: "Add Thread",
        btn_submit: "Launch Star",
        btn_submit_quote: "Quote",
        btn_submitting: "Uploading...",
        quote_suffix: " quoted"
    },
    recommendation: {
        loading_title: "Reading your trajectory...",
        loading_desc: "Connecting your past footprints and the stars you stayed at",
        fallback_title: "The constellation of <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span><br>is still faint.",
        fallback_desc: "But don't worry. <br>We've picked out some shining stories that have brightened many others' nights.<br><span class=\"text-sm opacity-70 mt-1 block\">As your footprints accumulate, we will find an orbit just for you.</span>",
        personal_title: "<span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}'s</span> Bookshelf,<br>The story to be placed next",
        personal_desc: "We found 5 stars that resonate with your taste.",
        label_empty_shelf: "The Empty Shelf",
        btn_refresh: "Get other recommendations",
        error_title: "Connection Unstable",
        btn_retry: "Retry",
        empty_data_title: "Not enough data yet",
        btn_browse: "Explore Works",
        // Widget Specific
        widget_title: "Looking for your<br>next favorite story?",
        widget_desc: "We selected 5 works based on {name}'s taste.",
        widget_desc_guest: "We selected 5 works based on your taste.",
        btn_check: "Check Recommendation"
    },
    star_station: {
        title: "Star Station",
        subtitle: "Enjoy works more freely.",
        my_stars: "My Stars",
        history_tab: "History",
        products_tab: "Products",
        payment_method: "Payment Method",
        btn_charge: "Recharge",
        history_empty: "No transaction history.",
        product_names: {
            stardust: "Stardust",
            shooting_star: "Shooting Star",
            little_bear: "Little Bear",
            silver_river: "Silver River",
            galaxy_master: "Galaxy Master",
            star_maker: "Star Maker"
        }
    },
    studio: {
        title: "Creator Studio",
        open_menu: "Open Menu",
        exit: "Exit",
        new_series: "New Series",
        lab_badge: "LAB",
        lab_title: "Da Vinci Lab",
        lab_desc: "Experience a new world of creation with AI.",
        total_views: "Total Views",
        total_likes: "Total Likes",
        total_followers: "Followers",
        weekly_performance: "Weekly Performance",
        views_trend_7d: "Views Trend (7d)",
        live_data: "Live",
        my_series_list: "My Series",
        total_series_count: "{n} Series",
        empty_series_title: "Start a New Story",
        empty_series_desc: "Unleash your imagination to the world.",
        btn_editor: "Editor",
        btn_settings: "Settings",
        btn_delete: "Delete",
        delete_modal_title: "Delete Series",
        delete_modal_content: "Are you sure you want to delete '{title}'? This action cannot be undone.",
        create_first_episode: "Create your first episode!",
        create_first_episode_desc: "Click 'New Episode' to start.",
        last_updated: "Last Updated: {date}",
        delete_episode_title: "Delete Episode",
        delete_episode_content: "Delete episode '{title}'?",

        // Toolbar
        bold: "Bold",
        italic: "Italic",
        highlight_red: "Highlight (Red)",
        highlight_blue: "Highlight (Blue)",
        save_preserve_status: "Save (Preserve Status)"
    },
    rating_guide: {
        title: "Content Rating Guide",
        all_title: "All Ages",
        all_desc: "Content suitable for all ages.<br>No or very mild violence, sexual content, or inappropriate language.",
        title_12: "12+ (Teens)",
        desc_12: "May contain mild violence, bad language, or horror.<br>Parental guidance suggested for children under 12.",
        title_15: "15+ (Young Adults)",
        desc_15: "May contain moderate violence, strong language, or mature themes.<br>May portray criminal behavior or social taboos.",
        title_19: "19+ (Adults Only)",
        desc_19: "Contains explicit sexual content, extreme violence, or abusive language.<br><strong class='text-red-500'>Legally restricted to adults 19+. Identity verification required.</strong>",
        disclaimer: "* Rating is the author's responsibility. False ratings may lead to forced changes or penalties.",
        confirm: "Understood"
    },
    davinci: {
        episode_settings: "Episode Settings",
        title: "Title",
        thumbnail: "Thumbnail",
        bgm: "BGM",
        add_block: "Add Block",
        text_block: "Text",
        image_block: "Image",
        upload_image: "Upload Image",
        upload_thumb: "Upload Thumbnail",
        upload_success: "Upload Success",
        bgm_placeholder: "Suno URL or MP3 Link",
        tip: "Tip:",
        drag_tip: "You can drag blocks to reorder them.",

        // DaVinci Settings
        project_settings: "Project Settings",
        isbn: "ISBN (Optional)",
        uci: "UCI (Identifier)",
        is_adult: "Adult Only (19+)",
        is_ai: "AI Generated Content",
        bgm_url_label: "BGM (Suno Link or MP3 URL)",
        suno_tip: "* Suno links are automatically converted to streaming URLs.",
        author_note: "Author's Note",
        save_settings: "Save Settings",
        cover_upload: "Upload Cover",

        // DaVinci List
        episode_management: "Episode Management",
        create_new_episode: "Add New Episode",
        new_episode_title_prompt: "New Episode Title:",
        create_fail: "Creation Failed",
        no_episodes: "No episodes found.",
        published_badge: "Published",
        draft_badge: "Draft",
        edit_btn: "Edit",

        // DaVinci Toolbox (Merged)
        recommend_size: "Recommended: 16:9",
        thumbnail_uploading: "Uploading Thumbnail...",
        thumbnail_applied: "Thumbnail Applied.",
        upload_fail: "Upload Failed: ",
        save_draft: "Save Draft",
        publish: "Publish",
        saving: "Saving...",
        published: "Published! Visible to readers.",
        publish_confirm: "Are you sure you want to publish?",
        preview_preparing: "Preparing preview...",
        guide: {
            title: "Button Guide",
            save: "Save",
            save_desc: "Saves changes.",
            draft: "Draft",
            draft_desc: "Switch to private.",
            publish: "Publish",
            publish_desc: "Make public. (Visible to readers)",
            auto_save: "Auto Save",
            auto_save_on: "ON (3s)",
            auto_save_desc: "Auto-saves every 3 seconds."
        }
    },




    intro: {
        slogan: "Human Creativity, AI Scalability",
        hero_title: "The Babel Fish",
        hero_subtitle: "for Cine-Novels.",
        status_active: "Translation Engine Active",
        status_cine: "Cine-Novel Format",
        desc_1: "Read Korean IPs instantly in <span class='text-white font-bold mx-1'>10 languages</span> with our non-destructive AI engine.",
        desc_2: "Experience the <span class='text-white font-bold mx-1'>World's First Hybrid Format</span> where visuals and novels merge.",
        cta_start: "Start Reading for Free",
        compare_title: "Destructive vs Non-Destructive",
        compare_desc: "We never touch the original pixels. See the difference.",
        compare_old: "Old Method (White Box)",
        compare_new: "Ssulwha Engine (R.A.P.S)",
        white_box_removed: "White Boxes Removed",
        format_title: "Beyond Static Images",
        format_desc: "Webtoon Visuals. Novel Depth. Cinematic Immersion.",
        geo_title: "AI-Driven Growth",
        geo_desc: "We don't do marketing. Our AI does.",
        term_log_1: "Analyzing content...",
        term_log_2: "Extracting keywords...",
        term_log_3: "Injecting JSON-LD metadata...",
        term_log_4: "Organic growth +300%",
        slider_old_title: "Old Method",
        slider_old_desc: "BLOCKS THE ART",
        slider_new_title: "Ssulwha Engine (R.A.P.S)",
        slider_new_desc_1: "\"This is how it should be.\"",
        slider_new_desc_2: "Text floats naturally, preserving the art.",
        phone_analyzing: "Analyzing...",
        phone_detected: "Detected",
        phone_text_1: "Is this my destiny?",
        phone_cine_ep: "CINE-NOVEL EP.01",
        phone_cine_text_1: "The neon lights flickered, reflecting in his cold eyes.",
        phone_cine_text_2: "\"It's not just translation,\" he muttered. \"It's a new reality.\"",
        footer_copyright: "Powered by R.A.P.S Engine."
    }
};
